import DnerhsApi from 'api/DnerhsApi';
import history from 'utils/History';
import jwtDecode from "jwt-decode";
import { eliminarSedeSeleccionada } from "services/UsuarioService";

const JWT_TOKEN_KEY = "dnerhs-jwt";

const login = async (username, password) => {
  const payload = {
    username,
    password,
  };
  try {
    DnerhsApi.defaults.headers.common["Authorization"] = "";

    const { data } = await DnerhsApi.post("/autenticar", {
      ...payload
    });


    let jwtToken = data.token;

    localStorage.setItem(JWT_TOKEN_KEY, jwtToken);

    DnerhsApi.defaults.headers.common['Authorization'] = `Bearer ${jwtToken}`;

    const token = jwtDecode(jwtToken);
    const now = new Date().getTime() / 1000;
    if (token.exp - now > 0) {
      return {
        role: token.role,
        status: "OK"
      };
    } else {
      return { status: "ERROR", message: "El token ha expirado, por favor vuelva a autenticarse." };
    }

  } catch (error) {
    if (error.response) {
      // Se ha recibido una respuesta del servidor pero con algún error
      switch (error.response.status) {
        case 400:
          return { status: "ERR", message: "Solicitud incorrecta. Por favor verifique los datos ingresados." };
        case 401:
          return { status: "ERR", message: "Usuario o contraseña incorrectos. Verifique sus credenciales e intente nuevamente." };
        case 403:
          return { status: "ERR", message: "Acceso denegado. No tiene los permisos necesarios para acceder al sistema." };
        case 500:
          return { status: "ERR", message: "Error interno del servidor. Por favor intente nuevamente más tarde." };
        default:
          return { status: "ERR", message: `Error inesperado: ${error.response.status}. Por favor intente nuevamente.` };
      }
    } else if (error.request) {
      // No se recibió respuesta del servidor (problema de red o el servidor no está disponible)
      return { status: "ERR", message: `No se pudo conectar con el servidor.Verifique su conexión a Internet y vuelva a intentarlo.` };
    } else {
      // Algo sucedió al configurar la solicitud
      return { status: "ERR", message: `Error en la solicitud: ${error.message}` };
    }
  }
};

const getUserPrincipal = () => {
  try {
    let jwtToken = localStorage.getItem(JWT_TOKEN_KEY);
    if (jwtToken) {
      let jwtTokenDecode = jwtDecode(jwtToken);
      const now = new Date().getTime() / 1000;
      if (!jwtTokenDecode.exp - now > 0) {
         throw Error("Token expirado");
      }
      return {
        role: jwtTokenDecode.role,
        username: jwtTokenDecode.sub,
        roleName: jwtTokenDecode.role?.descripcion,
        userId: jwtTokenDecode.id
      }
    } 
  } catch (error) {
    console.log(error);
  }

}

const logout = async () => {
  try {
    clearToken();
    eliminarSedeSeleccionada();
    history.push(`/login`);
    return { status: 'OK' };
  } catch (err) {
    return { status: 'ERR', message: err };
  }
};

const clearToken = () => {
  localStorage.removeItem(JWT_TOKEN_KEY);
  DnerhsApi.defaults.headers.common['Authorization'] = '';
}

const isAuthenticated = () => {
  return getUserPrincipal() ? true : false;
}

export {
  login,
  logout,
  getUserPrincipal,
  isAuthenticated,
  clearToken
}

